import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { HelperService } from '../helper/helper.service';
import {
  fetchCampaign,
  getCampaign,
  fetchInvolvedCampaigns
} from "../../store/campaign/campaign.actions";
import { Observable } from 'rxjs';
import { IState } from '@models/index';
import { getCampaignsSelector, getCampaignSelector, getInvolvedCampaignsSelector } from '@store/campaign/campaign.selectors';

@Injectable({
  providedIn: "root"
})
export class CampaignService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ campaign: IState }>
  ) {}

  getCampaignsSelector(): Observable<IState> {
    return this.store.select(getCampaignsSelector);
  }

  getCampaignSelector(): Observable<any> {
    return this.store.select(getCampaignSelector)
  }

  fetchCampaigns(page, filterOptions): void {
    this.store.dispatch(fetchCampaign({ page, filterOptions }));
  }

  fetchCampaign(id): void {
    this.store.dispatch(getCampaign({ id }))
  }

  getCampaigns(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/campaigns?${queryString}`);
  }

  getCampaign(id: string) {
    return this.http.get(`${this.backendUrl}/campaigns/campaign/${id}`);
  }

  getCampaignsByAffiliate(page: number, userID: string) {
    return this.http.get(`${this.backendUrl}/campaigns/user/${userID}/campaigns?page=${page}`);
  }

  getInvolvedCampaigns(){
    return this.http.get(`${this.backendUrl}/campaigns/?involved=true`);
  }

  fetchInvolvedCampaigns(): void {
    this.store.dispatch(fetchInvolvedCampaigns());
  }

  getInvolvedCampaignsSelector(){
    return this.store.select(getInvolvedCampaignsSelector);
  }

  getCampaignUrls(page, campaignId: any) {
    const params: any = {};
    if (!!page && page > 1) params.page = page;
    return this.http.get(`${this.backendUrl}/campaigns/campaign/${campaignId}/urls`, {
      params
    })
  }

  addCampaignUrls(params?) {
    return this.http.post(`${this.backendUrl}/campaigns/campaign/url`, params);
  }

  deleteCampaignUrls(campaignId: any, params = {}) {
    return this.http.delete(`${this.backendUrl}/campaigns/campaign/url/${campaignId}`, params);
  }

  editCampaignUrls(campaignId: any, params?) {
    return this.http.patch(`${this.backendUrl}/campaigns/campaign/url/${campaignId}`, params);
  }

}
